exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.m-login__logo[data-v-41f059f2] {\n  text-align: center;\n}\n.m-login__logo > img[data-v-41f059f2] {\n  width: 200px;\n}\n.centered[data-v-41f059f2] {\n  text-align: -webkit-center;\n}\n", "", {"version":3,"sources":["/home/superaccess/portal-local-2.0/Superaccess2.0/app/javascript/src/components/layout/activation/Activation.vue"],"names":[],"mappings":";AAAA;EACE,mBAAmB;CAAE;AAEvB;EACE,aAAa;CAAE;AAEjB;EACE,2BAA2B;CAAE","file":"Activation.vue","sourcesContent":[".m-login__logo {\n  text-align: center; }\n\n.m-login__logo > img {\n  width: 200px; }\n\n.centered {\n  text-align: -webkit-center; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-41f059f2","scoped":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app/javascript/src/components/layout/activation/Activation.vue
// module id = 800
// module chunks = 0 1 148